import React, {useEffect} from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {Field} from 'formik';
import AccessibleTypeahead from '../../../../shared/components/accessible-typeahead';
import {useDispatch, useSelector} from 'react-redux';
import {getReportColumns} from '../../../redux/lists';
import {Store} from '../../../types/store';

const ReportColumnField = () => {
  const dispatch = useDispatch();
  const reportColumns = useSelector((state: Store) => state.lists.reportColumns);

  useEffect(() => {
    dispatch(getReportColumns());
  }, []);

  return (
    <Field name="raisemeColumnName">
      {({field: {value, name}, form: {setFieldValue}}) => (
        <AccessibleTypeahead
          id="admin-university-column-name-typeahead"
          options={reportColumns}
          onSelect={(column: $TSFixMe): void => setFieldValue(name, column)}
          placeholder="Search for column"
          postFixIcon="search"
          size="medium"
          value={value}
          inputProps={{styles: "width: '100%'"}}
        />
      )}
    </Field>
  );
};

const columns = [
  {
    name: 'raisemeColumnName',
    title: 'Raise Me Column',
    width: '50%',
    sortable: true,
    FormField: ReportColumnField,
  },
  {
    name: 'sponsorColumnName',
    title: 'Sponsor Column',
    sortable: true,
  },
  {
    name: 'mappingType',
    hidden: true,
    editable: false,
  },
];

interface Props {
  universityId: string;
}

const ColumnMappings = ({universityId}: Props) => (
  <div>
    <h3>Report Column Mappings</h3>
    <EditableTable
      basePath={`/v1/sponsors/${universityId}/column-mappings?mappingType=reports`}
      defaultSortKey="raisemeColumnName"
      columns={columns}
      identifier={universityId}
      defaultValues={{
        mappingType: 'reports',
      }}
    />
  </div>
);

export default ColumnMappings;
